/**
 * @generated SignedSource<<03b853e487291d3b6cfa1fc0617fe44a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type FacilityType = "DINING" | "GOLF_COURSE" | "RACQUET" | "SIMULATOR";
import { FragmentRefs } from "relay-runtime";
export type useDepartmentGolfFacilitiesStartEndTime_department$data = {
  readonly facilities: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly startEndTime: {
          readonly endTime: string | null | undefined;
          readonly startTime: string | null | undefined;
        } | null | undefined;
        readonly type: FacilityType;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useDepartmentGolfFacilitiesStartEndTime_department";
};
export type useDepartmentGolfFacilitiesStartEndTime_department$key = {
  readonly " $data"?: useDepartmentGolfFacilitiesStartEndTime_department$data;
  readonly " $fragmentSpreads": FragmentRefs<"useDepartmentGolfFacilitiesStartEndTime_department">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useDepartmentGolfFacilitiesStartEndTime_department",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FacilityConnection",
      "kind": "LinkedField",
      "name": "facilities",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FacilityEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Facility",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FacilityStartEndTime",
                  "kind": "LinkedField",
                  "name": "startEndTime",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startTime",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endTime",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Department",
  "abstractKey": null
};

(node as any).hash = "9502535c73dc31d607ee350c4825f260";

export default node;
